import React from "react";
import { X } from "lucide-react";
import { CountryTransfert } from "../../../utils/database";
import TransfertsView from "../Transactions/TransactionsView";

interface CorridorTransactionsModalProps {
  transfert: CountryTransfert | null;
  isOpen: boolean;
  onClose: () => void;
}

const CorridorTransactionsModal: React.FC<CorridorTransactionsModalProps> = ({ transfert, isOpen, onClose }) => {
  if (!isOpen || !transfert) return null;

  const senderName = transfert.country_sender?.name || "?";
  const destName = transfert.country_destination?.name || "?";
  const corridorLabel = `${senderName} → ${destName}`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="flex flex-col w-full max-w-7xl max-h-[95vh] bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50">
          <div>
            <h2 className="text-xl font-bold text-gray-900">Transactions du corridor</h2>
            <p className="text-sm text-gray-600 mt-0.5">{corridorLabel}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            title="Fermer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          <TransfertsView
            senderCountryId={Number(transfert.country_sender_id)}
            receiverCountryId={Number(transfert.country_destination_id)}
            corridorLabel={corridorLabel}
          />
        </div>
      </div>
    </div>
  );
};

export default CorridorTransactionsModal;
